angular
  .module("digitalLeasing.module")
  .component("checkList", {
    templateUrl: "ng/components/digitalLeasing/checkList/checkList.view.html",
    bindings: {
      model: "=",
      validatePage: "&",
      snapshot: '<',
      portalRunned: "<"
    },
    controllerAs: "CheckListCtrl",
    controller: function DigitalLeasingController(
      $digitalService,
      $portalService,
      $financialApiService,
      $modalService,
      $timeout,
      $rootScope
    ) {
      var self = this;

      self.supportModel = {
        isInfo: false
      }

      self.$digitalService = $digitalService;
      self.$portalService = $portalService;
      self.$onInit = function () {
        self.showRejectionSectionFn();
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
        self.model = self.model;
        if (self.model.leasingData.preventivo.accettatoArc && !self.snapshot && self.$portalService.isAra()) {

          if (self.model.financialCustomer.metadata.autorizzazione.iban) {
            self.checkIbanValid();
          } else {
            $timeout(function () {
              $(".financial-leasing__footer").css("z-index", "-1");
              $modalService.openModal("noIban-modal")
            }, 1000)

          }
        }
        self.downloadIsCompleted = false;
        self.uploadInProgess = false;
        self.productIsChanged();
      };

      self.$onChanges = function (changes) {
        console.log("model changed! :", changes);
      };


      self.isEveryFileDownloaded = function (value) {
        self.downloadFileIsOk = value;
        checkIfPageIsOk();
      }

      self.isEveryFileUploaded = function (value) {
        self.uploadFileRequiredIsOk = value;
        checkIfPageIsOk();
      }

      var checkIfPageIsOk = function () {
        var test = true;
        var controlloAru = true;
        if (self.$portalService.isAru() && self.model.leasingData.preventivo.completatoArc) {
          if (self.model.leasingData.preventivo.documents.refused.length > 0 && self.model.leasingData.preventivo.documents.corrected.length == 0) {
            controlloAru = false;
          } else {
            controlloAru = true;
          }
        }
        if (self.model.leasingData.preventivo.documents.refused.length > 0 && self.$portalService.isAra()) {
          test = !!self.model.leasingData.preventivo.documents.message;
        }
        if (self.$portalService.isAra()) {
          test = test &&
            !!self.model.leasingData.preventivo.mailGestore;
        }
        // if (self.model.financialCustomer.metadata.autorizzazione.errorIban) {
        //   test = test && !!self.model.leasingData.preventivo.documents.message;
        // }
        if (controlloAru && test && !self.downloadFileIsOk && self.uploadFileRequiredIsOk) {
          self.validatePage({
            value: true
          })
          return;
        }
        self.validatePage({
          value: false
        })
      }

      self.uploadInProgress = function (value) {
        self.uploadInProgess = value;
      }

      self.infoPage = function () {
        checkIfPageIsOk();
      }

      self.productIsChanged = function () {
        self.checkProblemStatus = self.model.leasingData.preventivo.prodotto.beneContratto
          .some(function (element, index) {
            self.indexOfProblem = index;
            return element.stato != self.model.leasingData.preventivo.prodotto.bene.stato;
          })
      }

      self.checkMail = function (type, email) {

        switch (type) {
          case "email":
            self.model.leasingData.preventivo.mailGestore = email;
            checkIfPageIsOk();
            break;
          case "email2":
            self.model.leasingData.preventivo.mailGestore2 = email;
            checkIfPageIsOk();
            break;
          case "email3":
            self.model.leasingData.preventivo.mailGestore3 = email;
            checkIfPageIsOk();
            break;
        }
      }

      self.checkIbanValid = function () {
        var iban = self.model.financialCustomer.metadata.autorizzazione.iban;
        $financialApiService.checkIban(iban)
          .then(function (response) {
            if (!response.success) {
              $(".financial-leasing__footer").css("z-index", "-1");
              $modalService.openModal("ibanAnnulled-modal");
              self.model.financialCustomer.metadata.autorizzazione.errorIban = true;
            } else {
              if (self.model.financialCustomer.metadata.autorizzazione.errorIban) {
                $rootScope.$broadcast("addAlert", {
                  text: "LBL_IBAN_CHECK_OK"
                })
              }
              self.model.financialCustomer.metadata.autorizzazione.errorIban = false;
            }
            checkIfPageIsOk();

          })
          .catch(function (error) {
            console.log("error", error);
          })
      }

      self.closeModal = function (id) {
        $modalService.closeModal(id);
      }

      self.showRejectionSectionFn = function () {
        self.showRejectionSection =
          (((self.$portalService.isAru() && !self.snapshot) || self.portalRunned == 'ILEAF_ARU') && (self.model.leasingData.preventivo.status == 'P300' || self.model.leasingData.preventivo.status == 'P325'))
          || (((self.$portalService.isAra() && !self.snapshot) || self.portalRunned == 'ILEAF_ARA') && self.model.leasingData.preventivo.completatoArc && (self.model.leasingData.preventivo.status == 'P300' || self.model.leasingData.preventivo.status == 'P325' || self.model.leasingData.preventivo.status == 'P350' || self.model.leasingData.preventivo.status == 'P375' || self.model.leasingData.preventivo.status == 'P425' || self.model.leasingData.preventivo.status == 'P415' || self.model.leasingData.preventivo.status == 'P450'))

      }
    }
  });